/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'annotate-square': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>'
  }
})
